import { Http } from '@mygpt/app';

interface ClientConnectionsParams {
  aiId: string;
}

export interface ClientConnectionItem {
  connection_id: string;
  client_addr: string;
  ai_id: string;
  user_id: string;
  email: string;
  page_url: string;
  created_at: string;
  session_id: string;
  session_type: string;
}

/**
 * 获取访客列表
 * @param params
 * @returns
 */
export const clientConnections = (params: ClientConnectionsParams) => {
  const { aiId } = params;
  const { get } = Http.use();
  return get<ClientConnectionItem[]>(`/notification/${aiId}/client.connections`);
};
